// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { changePasswordWithEncryption } from '@api/selfServiceServices';
import { resetPasswordExpirationBanner } from '@common/utils/sessionStorage';
import { QueryKey } from '@portal/constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export type ChangePasswordParams = { newPassword: string };

export const useChangePassword = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, ChangePasswordParams>({
    mutationFn: (params: ChangePasswordParams) => changePasswordWithEncryption(params.newPassword),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [QueryKey.PASSWORD_EXPIRATION_INFO] });
      resetPasswordExpirationBanner();
    },
  });
};
